import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
}                     from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import SyntaxHighlighter from 'react-syntax-highlighter';

import {
  UserContext,
} from '../../user';

import { 
  fmtClient,
} from '../../client';

import { 
  fmtAthenaPreviewTableLink,
} from '../../utils/formatters';

const useStyles = makeStyles((theme) => ({
  root: {
  },
}));

const handleViewInAthena = () => {
  window.open(fmtAthenaPreviewTableLink('dl_metadata','inventory'),"_blank");
};

export default function InventoryAction(props) {
  const { resource, open, onClose } = props;

  const userContext=React.useContext(UserContext); 

  const classes = useStyles();

  const handleClose = () => {
    if(onClose) {
      onClose();
    }
  };

  const client_account_alias=fmtClient(resource.ClientAccountId,userContext);
  const client_account_id=resource.ClientAccountId;
  const resource_type=resource.ResourceType;
  const resource_id=resource.ResourceId;
  
  const resource_sql=`SELECT * FROM "dl_metadata"."inventory" 
WHERE client_account_id='${client_account_id}'
  AND resource_type='${resource_type}'
  AND resource_id='${resource_id}'
  AND snapshot='latest' 
LIMIT 10;`;

  const snapshots_sql=`SELECT resource_type, resource_id, snapshot, count(*)  objects, sum(size) AS bytes
FROM "dl_metadata"."inventory" 
WHERE client_account_id='${client_account_id}'
GROUP BY 1,2,3 ORDER BY 1,2,3;`;


  return(
    <Dialog
      className={classes.root}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <React.Fragment>
        <DialogTitle id="alert-dialog-title">
          View Inventory in Athena
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="prompt">
            When logged into your AWS console @ {client_account_alias}, you can view 
            S3 inventory data from Athena.  
          </DialogContentText>
          <DialogContentText id="resource">
            This will open a separate AWS console window with a generic table preview query for the
            dl_metadata.inventory table.  You can use the example queries below to view specific inventory data.
          </DialogContentText>
          <DialogContentText id="snapshots">
            Query contents of S3 inventory for the selected resource:
          </DialogContentText>
          <SyntaxHighlighter language="sql">
            {resource_sql}
          </SyntaxHighlighter>
          <DialogContentText id="snapshots">
            List the S3 inventory snapshots available:
          </DialogContentText>
          <SyntaxHighlighter language="sql" wrapLongLines>
            {snapshots_sql}
          </SyntaxHighlighter>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="outlined" color="primary">
            Close
          </Button>
          <Button onClick={handleViewInAthena} variant="outlined" color="primary" autoFocus>
            View in Athena
          </Button>
        </DialogActions>
      </React.Fragment>
    </Dialog>
  );
}

InventoryAction.propTypes = {
  resource: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

InventoryAction.defaultProps = {
  open: true,
};